import { useEffect, useRef, useState } from 'react';

import { GlobalFormats } from '../../../classess/main/globalFormats';
import {
    getLanguageObj, getResponse, handleResponseMessageAsync, isUndNullEmp, settings, LoadingSection, charactersRemainingGet, styles,
    awaitDelayAsync
} from '../../../helpers/main';
import { ToastService } from '../../../services/notifications/toasts/ToastService';
import useAuth from '../../../auth/UseAuth';
import Menu from '../../main/Menu';
import { Toast } from '../../../classess/notifications/toast';
import parse from 'html-react-parser';

const $ = window.jqGlobal || window.jQuery;

const { app, backend, icons, images, labels, messages, timers } = settings;

const currentMethod = 'ToastAdd';

export default function ToastAdd({
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
}) {
    //#region variables
    const auth = useAuth();
    const [toast, setToast] = useState(Toast?.getClass({}, false));
    const [errors, setErrors] = useState({
        type: '',
        controller: '',
        method: '',
        title: '',
        message: '',
    });
    const [charactersRemaining, setCharactersRemaining] = useState('');
    const [dataFormLength] = useState(Toast.minMaxLength(false));
    const [showData, setShowData] = useState(true);
    const [process, setProcess] = useState({
        showLoading: false,
        save: false,
        back: false,
    });
    const isMount = useRef(null);
    const controls = {
        buttons: {
            back: {
                defaultClass: 'btn btn-outline-secondary shadow-sm font-weight-bold mx-1 px-4',
                id: 'btnBack',
            },
            add: {
                defaultClass: 'btn btn-primary shadow-sm font-weight-bold mx-1 px-4',
                id: 'btnAdd',
            },
        },
        checkBoxs: {
            isActive: {
                id: 'chkIsActive',
            },
            isAuthenticated: {
                id: 'chkIsAuthenticated',
            },
        },
        icons: {
            add: {
                id: 'icoAdd',
                defaultClass: icons?.fasFa?.save,
            },
            back: {
                id: 'iconBack',
                defaultClass: icons?.fasFa?.arrowCircleLeft,
            },
        },
        inputs: {
            controller: {
                id: 'inpController',
            },
            method: {
                id: 'inpMethod',
            },
            title: {
                id: 'inpName',
            },
        },
        selects: {
            type: {
                id: 'selType'
            },
        },
        spiners: {
            add: {
                id: 'spAdd',
                defaultClass: '',
            }
        },
        textAreas: {
            toast: {
                id: settings.objects.html.notifications.toast.textArea.id,
            },
            toastHide: {
                id: settings.objects.html.notifications.toastHide.textArea.id,
                rows: 4,
            },
            toastHideInnerText: {
                id: settings.objects.html.notifications.toastHideInnerText.textArea.id,
                rows: 4,
            },
        }
    };
    //#endregion methods

    //#region methods
    //#region toast
    const toastAddPostAsync = async ({
        e = {},
        subMethod = '',
    } = {}) => {
        const currentMethod = 'toastAddPostAsync';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault?.();

            //#region validations
            response = setErrorsDefault({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;

            response = setData({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;

            response = validateFormData({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion validations

            setProcess(prev => ({ ...prev, save: true, showLoading: true }));

            //#region create toast
            // Basic cleanup of message
            const processedToast = {
                ...toast,
                message: toast?.message?.replace('<h6>', '')?.replace('</h6>', '')
            };

            response = await ToastService.addAsync({
                auth,
                data: processedToast,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion create toast

            // window.location.href = `${backend?.urls?.notifications}${backend?.urls?.toasts}/`;
            const toast_ = Toast.getClass(response?.result?.toast || {}, false);
            response.msgText = `${messages?.processCompletedSuccessfully?.[languageObj?.id]}.`;
            response.urlGoTo = `${backend?.urls?.notifications}${backend?.urls?.toasts}/${toast_?.id}`;
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            setProcess(prev => ({ ...prev, save: false, showLoading: false }));
            // CSN:
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    setShowData: setShowData,
                    showDataValue: response?.isSuccess,
                    languageId: languageObj?.id
                });
            }
        }
    }
    //#endregion toast

    //#region others
    const getData = async ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'getData';
        let response = getResponse({ type: 0 });
        try {
            setProcess(prev => ({ ...prev, showLoading: true }));

            //#region get data (toast)
            setToast({ ...Toast?.getClass({}, false), type: -2 });
            //#endregion get data (toast)

            //#region initialize summernote
            response = await summerNoteProcessAsync({ e: null, type: 1, subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;

            $(document).ready(function () {
                $(`#${settings?.summerNote?.btnEvents?.init}`).trigger('click');
            });
            //#endregion initialize summernote

            //#region set characters remainig
            setCharactersRemaining(
                charactersRemainingGet({
                    text: $(`#${controls?.textAreas?.toastHideInnerText?.id}`).val(),
                    maxLength: dataFormLength?.max?.message,
                    msgText: `${messages?.charactersRemaining?.[languageObj?.id]}:`,
                    subMethod: currentMethod,
                })?.result
            );
            //#endregion set characters remainig
        } catch (ex) {
            setShowData(false);
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount.current) return;

            setProcess(prev => ({ ...prev, showLoading: false }));

            // CSN:
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    setShowData: setShowData,
                    showDataValue: response?.isSuccess,
                    languageId: languageObj?.id
                });
            }
        }
    }

    const summerNoteProcessAsync = async ({
        e = {},
        type = 0,
        value = '',
        subMethod = '',
    } = {}) => {
        const currentMethod = 'summerNoteProcessAsync';
        let response = getResponse({ type: 0 });
        try {
            const eClick = 'click';
            switch (type) {
                case -1:
                    $(`#${settings?.summerNote?.btnEvents?.destroy}`).trigger(eClick);
                    break;
                case 0:
                    $(`#${settings?.summerNote?.btnEvents?.reset}`).trigger(eClick);
                    break;
                case 1:
                    $(`#${settings?.summerNote?.btnEvents?.init}`).trigger(eClick);
                    break;
                case 2:
                    $(`#${settings?.summerNote?.btnEvents?.code}`).trigger(eClick);
                    break;
                case 3:
                    $(`#${settings?.summerNote?.btnEvents?.isEmpty}`).trigger(eClick);
                    break;
                case 4:
                    $(`#${controls?.textAreas?.toast?.id}`).val(value);
                    $(`#${settings?.summerNote?.btnEvents?.setCode}`).trigger(eClick);
                    break;
                case 5:
                    $(`#${settings?.summerNote?.btnEvents?.enable}`).trigger(eClick);
                    break;
                case 6:
                    $(`#${settings?.summerNote?.btnEvents?.disable}`).trigger(eClick);
                    break;
                default:
                    $(`#${settings?.summerNote?.btnEvents?.destroy}`).trigger(eClick);
                    break
            }
            e?.preventDefault?.();
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const formDataSetAsync = async ({
        e = {},
        type = '',
        value = '',
        subMethod = '',
    } = {}) => {
        const currentMethod = 'formDataSetAsync';
        let response = getResponse({ type: 0 });
        try {
            switch (type) {
                case 'message':
                    setToast(prev => ({ ...prev, [type]: value }));
                    setErrors(prev => ({ ...prev, message: '' }));
                    setCharactersRemaining(
                        charactersRemainingGet({
                            text: $(`#${controls?.textAreas?.toastHideInnerText?.id}`).val(),
                            maxLength: dataFormLength?.max?.message,
                            msgText: `${messages?.charactersRemaining?.[languageObj?.id]}:`,
                            subMethod: `Message - ${currentMethod}`,
                        })?.result
                    );
                    break;
                case 'accounts':
                    setToast(prev => ({ ...prev, [type]: value }));
                    // toast.accounts = value;
                    break;
                default:
                    setToast(prev => ({ ...prev, [type]: value }));
                    break;
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const validateFormData = ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'validateFormData';
        let response = getResponse({ type: 0 });
        try {
            const errors_ = {
                type: '',
                controller: '',
                method: '',
                title: '',
                message: '',
            };

            let isWarning = false;

            if (isUndNullEmp({ data: toast?.type, subMethod: currentMethod })?.result || toast?.type <= -2 || toast?.type > 4) {
                errors_.type = `<b>${labels?.type?.[languageObj?.id]}</b> - ${messages?.itIsRequired?.[languageObj?.id]}<br/>`;
                isWarning = true;
            }

            if (isUndNullEmp({ data: toast?.controller, subMethod: currentMethod })?.result) {
                errors_.controller = `<b>${labels?.controller?.[languageObj?.id]}</b> - ${messages?.itIsRequired?.[languageObj?.id]}<br/>`;
                isWarning = true;
            }

            if (isUndNullEmp({ data: toast?.method, subMethod: currentMethod })?.result) {
                errors_.method = `<b>${labels?.method?.[languageObj?.id]}</b> - ${messages?.itIsRequired?.[languageObj?.id]}<br/>`;
                isWarning = true;
            }

            if (isUndNullEmp({ data: toast?.title, subMethod: currentMethod })?.result) {
                errors_.title = `<b>${labels?.title?.[languageObj?.id]}</b> - ${messages?.itIsRequired?.[languageObj?.id]}<br/>`;
                isWarning = true;
            }

            if (isUndNullEmp({ data: toast?.message, subMethod: currentMethod })?.result) {
                errors_.message = `<b>${labels?.message?.[languageObj?.id]}</b> - ${messages?.itIsRequired?.[languageObj?.id]}<br/>`;
                isWarning = true;
            }

            if (isWarning) {
                setErrors(prev => ({ ...prev, ...errors_ }));
                response = getResponse({ type: 1 });
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setErrorsDefault = ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setErrorsDefault';
        let response = getResponse({ type: 0 });
        try {
            setErrors({
                type: '',
                controller: '',
                method: '',
                title: '',
                message: '',
            });
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setData = ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setData';
        let response = getResponse({ type: 0 });
        try {
            setCharactersRemaining(
                charactersRemainingGet({
                    text: $(`#${controls?.textAreas?.toastHideInnerText?.id}`).val(),
                    maxLength: dataFormLength?.max?.message,
                    msgText: `${messages?.charactersRemaining?.[languageObj?.id]}:`,
                    subMethod: currentMethod,
                })?.result
            );

            const toastMsg = $(`#${controls?.textAreas?.toast?.id}`)?.summernote('code');
            setToast(prev => ({ ...prev, message: toastMsg }));
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const goToBack = async ({
        e = {},
        subMethod = '',
    } = {}) => {
        const currentMethod = 'goToBack';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault?.();
            setProcess(prev => ({ ...prev, back: true, showLoading: true }));
            await awaitDelayAsync({ delayTime: timers?.oneSecond });

            window.location.href = `${backend?.urls?.notifications}${backend?.urls?.toasts}/`;
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            setProcess(prev => ({ ...prev, back: false, showLoading: false }));
            // CSN:
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    setShowData: setShowData,
                    showDataValue: response?.isSuccess,
                    languageId: languageObj?.id
                });
            }
        }
    }

    useEffect(() => {
        isMount.current = true;
        getData({ subMethod: 'form - onLoad' });
        return () => {
            isMount.current = false;
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    //#endregion others
    //#endregion methods
    return (
        <div>
            <Menu viewName={app?.views?.settings?.settings} process={app?.views?.notifications?.toast?.toast} />

            <div className='content-wrapper bg-transparent'>

                {/* Content Header (Page header) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2 align-items-center bg-white p-3 rounded shadow-lg mx-0'>
                            <div className='col-sm-6'>
                                <h4 className='m-0 font-weight-bold text-dark'>{labels?.notificationsToast?.[languageObj?.id]}</h4>
                            </div>
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right bg-transparent mb-0'>
                                    <li className='breadcrumb-item'><a href='/'>{labels?.home?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item'><a href={`${backend?.urls?.notifications}${backend?.urls?.toasts}`}>{labels?.notificationsToast?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item active text-primary'>{labels?.add?.[languageObj?.id]}</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                {/* /.content-header */}

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>
                        {auth?.isLoged({ subMethod: currentMethod })?.result ? (
                            <div className='row'>
                                <div className='col-12'>
                                    <div hidden={!showData}>
                                        <form onSubmit={(e) => toastAddPostAsync({ e: e, subMethod: 'form - onSubmit' })}>
                                            <div className={settings?.html?.cards?.default} style={{ borderRadius: '10px' }}>
                                                <LoadingSection alt='loadingSection'
                                                    className='overlay dark text-white'
                                                    height={20}
                                                    hidden={!process.showLoading}
                                                    width={20}
                                                    languageId={languageObj?.id}
                                                    subMethod={currentMethod} />

                                                <div className='card-header bg-white border-bottom-0 pt-4 px-4'>
                                                    <div className='d-flex align-items-center'>
                                                        <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                                                            style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                            <img alt='notificationsToast' style={styles?.cardHeaderLogo} src={images?.icons?.notificationsToasts} />
                                                        </div>
                                                        <div className='d-flex flex-column'>
                                                            <h5 className='mb-0 font-weight-bold text-dark'>{labels?.notificationsToast?.[languageObj?.id]}</h5>
                                                            <div className='mt-1'>
                                                                <span className='badge badge-pill badge-info px-2 py-1 text-uppercase' style={settings?.html?.badges?.micro}>
                                                                    <i className={`${icons?.fasFa?.plus} mr-1`}></i> {labels?.add?.[languageObj?.id]}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='card-body px-4 pb-4'>
                                                    <div className='row'>
                                                        <div className='col-12 col-md-6'>
                                                            <div className='form-group mb-3'>
                                                                <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                                    <i className={`${icons?.listUl} mr-1`} /> {labels?.type?.[languageObj?.id]}
                                                                </small>
                                                                <select id={controls?.selects?.type.id}
                                                                    className='custom-select bg-light border-0 shadow-sm text-dark'
                                                                    style={{ borderRadius: '5px' }}
                                                                    value={!isUndNullEmp({ data: toast, subMethod: '' })?.result && !isUndNullEmp({ data: toast?.type, subMethod: currentMethod })?.result ?
                                                                        toast?.type : -2
                                                                    }
                                                                    onChange={(e) => setToast(prev => ({ ...prev, type: parseInt(e?.target?.value), }))}
                                                                    onFocus={() => setErrors(prev => ({ ...prev, type: '' }))}
                                                                    disabled={process.showLoading || process.save}
                                                                    placeholder={labels?.type?.[languageObj?.id]}
                                                                    title={labels?.type?.[languageObj?.id]}>
                                                                    <option key={-2} value={-2}>{messages?.selectType[languageObj?.id]}</option>
                                                                    {settings.types?.map((type) => <option key={type.id}
                                                                        value={type.id}>{!isUndNullEmp({ data: settings?.labels[type?.name], subMethod: currentMethod })?.result ? settings?.labels[type?.name][languageObj?.id] : type?.name}
                                                                    </option>)}
                                                                </select>
                                                                <div className='form-text' style={styles?.inputMsgAlert}>{parse(errors?.type)}</div>
                                                            </div>

                                                            <div className='form-group mb-3'>
                                                                <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                                    <i className={`${icons?.fasFa?.cog} mr-1`} /> {labels?.controller?.[languageObj?.id]}
                                                                </small>
                                                                <input id={controls?.inputs?.controller?.id}
                                                                    className='form-control bg-light border-0 shadow-sm text-dark'
                                                                    style={{ borderRadius: '5px' }}
                                                                    maxLength={dataFormLength?.max?.controller}
                                                                    onChange={(e) => setToast(prev => ({ ...prev, controller: e?.target?.value }))}
                                                                    onFocus={() => setErrors(prev => ({ ...prev, controller: '' }))}
                                                                    disabled={process.showLoading || process.save}
                                                                    value={!isUndNullEmp({ data: toast, subMethod: controls?.inputs?.controller?.id, })?.result && !isUndNullEmp({ data: toast?.controller, subMethod: controls?.inputs?.controller?.id, })?.result ?
                                                                        toast?.controller : ''}
                                                                    placeholder={labels?.controller?.[languageObj?.id]}
                                                                    title={labels?.controller?.[languageObj?.id]} />
                                                                <div className='form-text' style={styles?.inputMsgAlert}>{parse(errors?.controller)}</div>
                                                            </div>

                                                            <div className='form-group mb-3'>
                                                                <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                                    <i className={`${icons?.fasFa?.cogs} mr-1`} /> {labels?.method?.[languageObj?.id]}
                                                                </small>
                                                                <input id={controls?.inputs?.method?.id}
                                                                    className='form-control bg-light border-0 shadow-sm text-dark'
                                                                    style={{ borderRadius: '5px' }}
                                                                    maxLength={dataFormLength?.max?.method}
                                                                    onChange={(e) => setToast(prev => ({ ...prev, method: e?.target?.value }))}
                                                                    onFocus={() => setErrors(prev => ({ ...prev, method: '' }))}
                                                                    disabled={process.showLoading || process.save}
                                                                    value={!isUndNullEmp({ data: toast, subMethod: controls?.inputs?.method?.id, })?.result && !isUndNullEmp({ data: toast?.method, subMethod: controls?.inputs?.method?.id, })?.result ?
                                                                        toast?.method : ''}
                                                                    placeholder={labels?.method?.[languageObj?.id]}
                                                                    title={labels?.method?.[languageObj?.id]} />
                                                                <div className='form-text' style={styles?.inputMsgAlert}>{parse(errors?.method)}</div>
                                                            </div>

                                                            <div className='form-group mb-3 d-flex align-items-center'>
                                                                <input id={controls?.checkBoxs?.isActive?.id}
                                                                    type='checkbox'
                                                                    data-toggle='toggle'
                                                                    data-size='xs'
                                                                    data-width={50}
                                                                    data-onstyle='primary'
                                                                    data-on={labels?.yes?.[languageObj?.id]}
                                                                    data-off={labels?.no?.[languageObj?.id]}
                                                                    disabled={process.showLoading || process.save}
                                                                    onClick={(e) => setToast(prev => ({ ...prev, isActive: e?.target?.checked }))}
                                                                    onChange={(e) => setToast(prev => ({ ...prev, isActive: e?.target?.checked }))} />
                                                                <label className='control-label mb-0 ml-2'
                                                                    htmlFor={controls?.checkBoxs?.isActive?.id}
                                                                    style={{ cursor: process.showLoading || process.save ? 'default' : 'pointer' }}>
                                                                    {labels?.isActive?.[languageObj?.id]}
                                                                </label>
                                                            </div>

                                                            <div className='form-group mb-3 d-flex align-items-center'>
                                                                <input id={controls?.checkBoxs?.isAuthenticated?.id}
                                                                    type='checkbox'
                                                                    data-toggle='toggle'
                                                                    data-size='xs'
                                                                    data-width={50}
                                                                    data-onstyle='primary'
                                                                    data-on={labels?.yes?.[languageObj?.id]}
                                                                    data-off={labels?.no?.[languageObj?.id]}
                                                                    disabled={process.showLoading || process.save}
                                                                    onClick={(e) => setToast(prev => ({ ...prev, isAuthenticated: e?.target?.checked }))}
                                                                    onChange={(e) => setToast(prev => ({ ...prev, isAuthenticated: e?.target?.checked }))} />
                                                                <label className='control-label mb-0 ml-2'
                                                                    htmlFor={controls?.checkBoxs?.isAuthenticated?.id}
                                                                    style={{ cursor: process.showLoading || process.save ? 'default' : 'pointer' }}>
                                                                    {labels?.isAuthenticated?.[languageObj?.id]}
                                                                </label>
                                                            </div>
                                                        </div>

                                                        <div className='col-12 col-md-6'>
                                                            <div className='form-group mb-3'>
                                                                <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                                    <i className={`${icons?.fasFa?.spellCheck} mr-1`} /> {labels?.title?.[languageObj?.id]}
                                                                </small>
                                                                <input id={controls?.inputs?.title?.id}
                                                                    className='form-control bg-light border-0 shadow-sm text-dark'
                                                                    style={{ borderRadius: '5px' }}
                                                                    maxLength={dataFormLength?.max?.title}
                                                                    onChange={(e) => setToast(prev => ({ ...prev, title: e?.target?.value }))}
                                                                    onFocus={() => setErrors(prev => ({ ...prev, title: '' }))}
                                                                    disabled={process.showLoading || process.save}
                                                                    value={!isUndNullEmp({ data: toast, subMethod: controls?.inputs?.title?.id, })?.result && !isUndNullEmp({ data: toast?.title, subMethod: controls?.inputs?.title?.id, })?.result ?
                                                                        toast?.title : ''}
                                                                    placeholder={labels?.title?.[languageObj?.id]}
                                                                    title={labels?.title?.[languageObj?.id]} />
                                                                <div className='form-text' style={styles?.inputMsgAlert}>{parse(errors?.title)}</div>
                                                            </div>

                                                            <div className='form-group mb-3'>
                                                                <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                                    <i className={`${icons?.fasFa?.edit} mr-1`} /> {labels?.message?.[languageObj?.id]}
                                                                </small>
                                                                <textarea id={controls?.textAreas?.toast?.id}
                                                                    className='form-control bg-light border-0 shadow-sm text-dark'
                                                                    style={{ borderRadius: '5px' }}
                                                                    maxLength={dataFormLength?.max?.message}
                                                                    disabled={process.showLoading || process.save}
                                                                    onFocus={() => setErrors(prev => ({ ...prev, message: '' }))}
                                                                    placeholder={labels?.message?.[languageObj?.id]} />
                                                                <div className='form-text' style={styles?.labelMsgInfo}>{parse(charactersRemaining)}</div>
                                                                <div className='form-text' style={styles?.labelMsgAlert}>{parse(errors?.message)}</div>
                                                            </div>
                                                            <div className='form-group'>
                                                                <textarea className='form-control'
                                                                    hidden={true}
                                                                    id={controls?.textAreas?.toastHide?.id}
                                                                    maxLength={dataFormLength?.max?.message}
                                                                    title={labels?.message?.[languageObj?.id]}
                                                                    onClick={(e) => formDataSetAsync({ e: e, type: 'message', value: e?.target?.value, subMethod: 'textAreaMessage' })}
                                                                    onFocus={() => {
                                                                        setErrors(prev => ({ ...prev, message: '' }))
                                                                    }}
                                                                    placeholder={labels?.message?.[languageObj?.id]}
                                                                    rows={controls?.textAreas?.toastHide?.rows} />
                                                            </div>
                                                            <div className='form-group'>
                                                                <textarea className='form-control'
                                                                    hidden={true}
                                                                    id={controls?.textAreas?.toastHideInnerText?.id}
                                                                    maxLength={dataFormLength?.max?.message}
                                                                    title={labels?.message?.[languageObj?.id]}
                                                                    placeholder={labels?.message?.[languageObj?.id]}
                                                                    rows={controls?.textAreas?.toastHideInnerText?.rows} />
                                                            </div>
                                                            {/* Summernote (buttons)*/}
                                                            <div className='form-group'
                                                                hidden={true}>
                                                                <button className='btn btn-sm btn-outline-primary '
                                                                    id={settings?.summerNote?.btnEvents?.setCode}
                                                                    title='set data'
                                                                    type='button'>
                                                                    <i className={icons?.fasFa?.edit}></i>
                                                                </button>
                                                                <button className='btn btn-sm btn-outline-secondary mx-1'
                                                                    id={settings?.summerNote?.btnEvents?.isEmpty}
                                                                    title='is empty?'
                                                                    type='button'>
                                                                    <i className={icons?.squareMinus}></i>
                                                                </button>
                                                                <button className='btn btn-sm btn-outline-success'
                                                                    id={settings?.summerNote?.btnEvents?.code}
                                                                    title='get data'
                                                                    type='button'>
                                                                    <i className={icons?.fasFa?.check}></i>
                                                                </button>
                                                                <button className='btn btn-sm btn-outline-info mx-1'
                                                                    id={settings?.summerNote?.btnEvents?.reset}
                                                                    title='clear'
                                                                    type='button'>
                                                                    <i className={icons?.fileFar}></i>
                                                                </button>
                                                                <button className='btn btn-sm btn-outline-info'
                                                                    id={settings?.summerNote?.btnEvents?.init}
                                                                    title='initialize'
                                                                    type='button'>
                                                                    <i className={icons?.fasFa?.eye}></i>
                                                                </button>
                                                                <button className='btn btn-sm btn-outline-warning mx-1'
                                                                    id={settings?.summerNote?.btnEvents?.destroy}
                                                                    title='destroy'
                                                                    type='button'>
                                                                    <i className={icons?.fasFa?.eyeSlash}></i>
                                                                </button>
                                                                <button className='btn btn-sm btn-outline-default'
                                                                    id={settings?.summerNote?.btnEvents?.enable}
                                                                    title='enable'
                                                                    type='button'>
                                                                    <i className={icons?.fasFa?.eyeSlash}></i>
                                                                </button>
                                                                <button className='btn btn-sm btn-outline-secondary'
                                                                    id={settings?.summerNote?.btnEvents?.disable}
                                                                    title='disable'
                                                                    type='button'>
                                                                    <i className={icons?.fasFa?.eyeSlash}></i>
                                                                </button>
                                                            </div>
                                                            {/* Summernote (buttons)*/}
                                                        </div>
                                                    </div>

                                                </div>

                                                <div className='card-footer border-top-0 pb-4 px-4 bg-white'>
                                                    <div className='d-flex justify-content-end w-100'>
                                                        <button id={controls?.buttons?.add?.id}
                                                            className={controls?.buttons?.add?.defaultClass}
                                                            disabled={process.save || process.showLoading}
                                                            style={{ borderRadius: '5px' }}
                                                            title={labels?.add?.[languageObj?.id]}
                                                            type='submit'>
                                                            {process.save ? (
                                                                <span className={settings?.react?.html?.spinner?.borderSm}
                                                                    role='status' aria-hidden='true'></span>
                                                            ) : (
                                                                <i id={controls?.icons?.add?.id}
                                                                    className={controls?.icons?.add?.defaultClass} />
                                                            )} {labels?.add?.[languageObj?.id]}
                                                        </button>

                                                        <button id={controls?.buttons?.back?.id}
                                                            className={controls?.buttons?.back?.defaultClass}
                                                            disabled={process.back || process.showLoading}
                                                            style={{ borderRadius: '5px' }}
                                                            title={labels?.back?.[languageObj?.id]}
                                                            type='button'
                                                            onClick={(e) => goToBack({ e: e, subMethod: 'btnBack' })}>
                                                            {process.back ? (
                                                                <span className={settings?.react?.html?.spinner?.borderSm}
                                                                    role='status' aria-hidden='true'></span>
                                                            ) : (
                                                                <i id={controls?.icons?.back?.id}
                                                                    className={controls?.icons?.back?.defaultClass} />
                                                            )} {labels?.back?.[languageObj?.id]}
                                                        </button>
                                                    </div>
                                                </div>
                                                {/* /.card-body */}
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div></div>
                        )}
                    </div>
                </section>

            </div>
        </div>
    )
}